<template>
  <div>
    <el-form ref="params" :model="params">
    <el-row :gutter="5">
      <el-col :span="8" :xs="24">
        <el-form-item prop="thirdPartyOrderId">
          <el-input v-model="params.thirdPartyOrderId" maxlength="32" placeholder="订单单号"/>
        </el-form-item>
      </el-col>
      <el-col :span="7" :xs="24">
        <!-- <el-date-picker
            v-model="time"
            :clearable="false"
            :picker-options="pickerOptions"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            value-format="timestamp"/> -->
            <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          />
      </el-col>
      <el-col :span="2" :xs="12">
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
      <el-col :span="2" :xs="12">
        <el-button plain type="success" @click="reset">重置</el-button>
      </el-col>
    </el-row>
    </el-form>
    <el-table :data="records" stripe>
      <el-table-column fixed label="充值编号" prop="thirdPartyOrderId"/>
      <el-table-column label="账户类型">
        <template #default="scope">
          <template v-if="scope.row.memberType=='1'">
            公众用户
          </template>
          <template v-else-if="scope.row.memberType=='2'">
            小程序用户
          </template>
          <template v-else-if="scope.row.memberType=='3'">
            电卡
          </template>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone"/>
      <el-table-column label="订单金额" prop="payMoney"/>
      <el-table-column label="支付方式">
        <template #default="scope">
          <template v-if="scope.row.typeOfPayment=='1'">
            微信支付
          </template>
          <template v-else-if="scope.row.typeOfPayment=='2'">
            支付宝支付
          </template>
          <template v-else-if="scope.row.typeOfPayment=='3'">
            代充
          </template>
        </template>
      </el-table-column>
      <el-table-column label="订单时间">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <el-table-column label="付款时间">
        <template #default="scope">
          {{ timeFormat(scope.row.payTime) }}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          <template v-if="scope.row.state==='0'">
            未支付
          </template>
          <template v-else-if="scope.row.state==='1'">
            已支付
          </template>
          <template v-else-if="scope.row.state==='-1'">
            超时
          </template>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total"/>
    <el-dialog :visible.sync="detailDialog"
               title="订单详细">
      <el-row :gutter="5">
        <el-col :span="6">订单编号:</el-col>
        <el-col :span="6">{{ detailForm.number }}</el-col>
        <el-col :span="6">订单金额:</el-col>
        <el-col :span="6">{{ detailForm.money }}</el-col>
        <el-col :span="6">订单时间:</el-col>
        <el-col :span="6">{{ detailForm.time }}</el-col>
        <el-col :span="6">支付金额:</el-col>
        <el-col :span="6">{{ detailForm.payMoney }}</el-col>
        <el-col :span="6">所属用户:</el-col>
        <el-col :span="6">{{ detailForm.user }}</el-col>
        <el-col :span="6">付款方式:</el-col>
        <el-col :span="6">{{ detailForm.mode }}</el-col>
        <el-col :span="6">绑定号码:</el-col>
        <el-col :span="6">{{ detailForm.number }}</el-col>
        <el-col :span="6">付款时间:</el-col>
        <el-col :span="6">{{ detailForm.payTime }}</el-col>
        <el-col :span="6">备注信息:</el-col>
        <el-col :span="6">{{ detailForm.message }}</el-col>
        <el-col :span="6">当前余额:</el-col>
        <el-col :span="6">{{ detailForm.balance }}</el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>

import getPayLogByPage from "@/api/fund/pay-log-manage/getPayLogByPage";
import timeMixin from "@/mixin/timeMixin";
import searchMixin from "@/mixin/searchMixin";
import pageMixin from "@/mixin/pageMixin";
import dialogMixin from "@/mixin/dialogMixin";
import createdMixin from "@/mixin/createMixin";
import Page from "@/components/Page";

export default {
  name: "ElectricityCardDetailTwo", components: {Page},
  mixins: [pageMixin, dialogMixin, createdMixin, timeMixin, searchMixin],
  data() {
    return {
      params: {
        memberType: 3,
        memberId: this.$route.query.id,
        startTime: undefined,
        endTime: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      detailDialog: false,
      time: "",
      detailForm: {
        number: "1",
        money: "1",
        time: "1",
        payMoney: "1",
        user: "1",
        mode: "1",
        payTime: "1",
        message: "1",
        balance: "1"
      },
      records: []
    }
  },
  methods: {
    // reset(){
    //     this.params.startTime = undefined
    //     this.params.endTime = undefined
    //     this.fetchData()
    // },
    fetchData() {
      getPayLogByPage(this.params, this.current, this.size).then(res => {
        this.total = res.data.total;
        this.records = res.data.records;
      })
    },
  },
}
</script>

